<template>
  <div>
    <div v-if="inSplash" class='splash' :class="{ transparent: !inSplash }">
      <welcome-button delay="5000" @wb-welcome='handleWelcome'>Welcome</welcome-button>
      <flying-bird2 flight-time-secs="10-13" wing-time-secs="1.4" start-delay-secs="1.5" y="~33,6vw" bird-size="12"></flying-bird2>
      <flying-bird2 flight-time-secs="10-13" wing-time-secs="1.2" start-delay-secs="1" y="~33,7vw" bird-size="19"></flying-bird2>
      <flying-bird2 flight-time-secs="10-13" wing-time-secs="1.5" start-delay-secs="2" y="~33,5vw" bird-size="9"></flying-bird2>
      <flying-bird2 flight-time-secs="9-16" wing-time-secs="1.1" start-delay-secs="1.7" y="33vw" bird-size="15"></flying-bird2>

      <h1 class='title'>Podere Ampella</h1>
      <h1 class='byline'>Stunning Villas in Tuscany</h1>
    </div>
    <div class="fadeTransition" :class="{ transparent: inSplash, opaque: !inSplash }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import FlyingBird2 from './FlyingBird2'
import WelcomeButton from './WelcomeButton'

export default {
  props: ['delay'],
  mounted () {
    setTimeout(() => {
      this.inSplash = false
    }, this.delay || 5000)
  },
  data () {
    return {
      inSplash: true
    }
  },
  methods: {
    handleWelcome () {
      this.inSplash = false
    }
  },
  components: {
    FlyingBird2,
    WelcomeButton
  }
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

.fadeTransition {
  transition: opacity 1s linear;
}

.transparent {
  opacity: 0;
}
.opaque {
  opacity: 1;
}

.title {
  padding: 0.5em 1em 0em 1em;
  margin: 0;
  text-align: center;
  font: 400 40pt Tangerine;
  color: rgb(104, 95, 95);
  animation: fadeInAndGrow 0.5s ease-in-out;
  transform: scale(1.2);
}

.byline {
  margin: 0;
  text-align: center;
  font: 400 28pt Tangerine;
  color: rgba(165, 109, 35, 0.794);
  animation: fadeInAndGrow 3s ease-in-out;
  transform: scale(1.2);
  padding: 0.2em 0.5em;
}

.splash {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(../assets/podamppainting.png) bottom no-repeat,
    url(../assets/pasky.jpg) top no-repeat;
  background-size: 100%, cover;
  animation: pushUp 1.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  z-index: 100000;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes pushUp {
  0% {
    background-position-y: 100vh, top;
    opacity: 0;
  }
}

@keyframes fadeInAndGrow {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1.2);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Splash.vue